<template>
<div>
  <div class="name" :style="{ color: rankColor(stampData) }">
    <div class="img">
      <img :src="rankMark(stampData)" />
    </div>
    {{ rankName(stampData) }}ランク
  </div>
  <div class="label">
    (この期間に獲得したスタンプ：{{ sumStampCount(stampData) }}個)
  </div>
</div>
</template>

<script>
import {
  rankName,
  rankMark,
  rankColor,
  sumStampCount
} from '../../utils/StampUtil.js'

export default {
  name: 'StampHistory',
  props: ['stampData'],
  components: {},
  data: function () {
    return {}
  },
  created() {},
  computed: {},
  methods: {
    rankName,
    rankMark,
    rankColor,
    sumStampCount
  }
}
</script>

<style lang="scss" scoped>
.name {
  div.img {
    padding: 5px;
    height: 100%;

    img {
      height: 100%;
    }
  }

  margin: 10px 0 5px;
  font-size: 6vw;
  font-weight: bold;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.label {
  color: #c4c4c5;
  font-weight: bold;
  // margin: 5px 0;
}
</style>
